import { Injectable } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataItemNames, AppMetaDataService } from '../../../meta-data/app-meta-data.service';
import { WachterUserExt } from '../../../shared/models/wachter-user.model';
import { CodeValuePermitTeam, EthosWachterDepartmentAllItems, PermitEntity, PermitRequestEntity, PermitsMetaDataItemNames, PermitsMetaDataLookups } from '../meta-data/permits-meta-data.service';
import { PermitTeamData } from '../models/permit-team-data.model';
import { PermitRequestService } from '../services/permit-request.service';
import { WachterDivisions } from '../meta-data/constants/wachter-divisions.enum';
import { WachterTeams } from '../meta-data/constants/wachter_teams.enum';

@DwCustomContextDefinition({
    keyName: 'permitPermitTypesContext',
    display: 'Permit - Permit Types',
    isGlobal: false,
    parentItem: PermitsMetaDataItemNames.Permit
})
@Injectable()
export class PermitPermitTypeContextService extends DwCustomContextBase {

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {

            // Get permit data from the resolved context
            const permitRequest: PermitEntity = resolvedContext?.data;

            // Get a list of permit type ids for the related table
            // We need to filter out deleted items (the multi-select marks records as deleted so they can be removed on the server on save)
            const permitTypeCvs =  permitRequest?.PermitPermitType?.filter(pt => !pt._isDeleted).map(pt => pt.PermitTypeCv);

            // Return an option with just the permit types
            return {
                PermitTypes : permitTypeCvs || []
            };
        });

        contextDef.attributes = [];
        contextDef.useItemMetaData = false;

        // Adding a custom attribute to the context so we can select it in the user interface
        var hasPermissionAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 'PermitTypes', 'Permit Types', DwAttributeType.Integer, DwControlType.DropDownList);
        
        hasPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        hasPermissionAttr.Attribute.IsLookup = true;
        hasPermissionAttr.Attribute.MetaDataLookupId = PermitsMetaDataLookups.CodeValuePermitType;
    }

}